import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function LandingPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-950 to-slate-900 flex flex-col">
      <nav className="px-8 py-5 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="text-3xl">⚖</span>
          <span className="text-xl font-bold text-white">LexQuant</span>
        </div>
        <button onClick={() => navigate('/login')}
          className="px-5 py-2 bg-blue-600 text-white rounded-lg text-sm font-semibold hover:bg-blue-500 transition-colors">
          Sign In
        </button>
      </nav>

      <main className="flex-1 flex flex-col items-center justify-center text-center px-6 pb-24">
        <div className="inline-flex items-center gap-2 bg-blue-900/50 text-blue-300 text-xs font-semibold px-3 py-1.5 rounded-full mb-6 border border-blue-700">
          <span>●</span> AI-powered legal intelligence
        </div>
        <h1 className="text-5xl font-extrabold text-white leading-tight max-w-3xl mb-6">
          Your AI legal team,{' '}
          <span className="text-blue-400">available 24/7</span>
        </h1>
        <p className="text-slate-400 text-lg max-w-xl mb-10">
          Upload contracts for instant risk scoring. Chat with specialist AI lawyers.
          Understand your rights — in plain English, not legalese.
        </p>
        <div className="flex gap-4">
          <button onClick={() => navigate('/login?mode=signup')}
            className="px-8 py-3.5 bg-blue-600 text-white rounded-xl font-semibold hover:bg-blue-500 transition-colors shadow-lg shadow-blue-900/50">
            Get Started Free
          </button>
          <button onClick={() => navigate('/login')}
            className="px-8 py-3.5 border border-slate-600 text-slate-300 rounded-xl font-semibold hover:bg-slate-800 transition-colors">
            Sign In
          </button>
        </div>

        <div className="mt-16 grid grid-cols-3 gap-6 max-w-2xl">
          {[
            { icon: '📊', title: 'Contract Risk Score', desc: 'Instant 0-100 risk rating on any contract' },
            { icon: '⚕', title: '6 AI Specialists', desc: 'Corporate, employment, property, IP, litigation, family' },
            { icon: '🔒', title: 'Private Vault', desc: 'Your documents never leave your secure account' },
          ].map(({ icon, title, desc }) => (
            <div key={title} className="bg-slate-800/50 border border-slate-700 rounded-xl p-5 text-left">
              <div className="text-2xl mb-2">{icon}</div>
              <p className="text-white font-semibold text-sm mb-1">{title}</p>
              <p className="text-slate-400 text-xs">{desc}</p>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}
